/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Order_Section_DeliveryInputs */

const vi_order_section_delivery = /** @type {(inputs: Order_Section_DeliveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giao hàng & thanh toán`)
};

/**

* @param {Order_Section_DeliveryInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const order_section_delivery = /** @type {((inputs?: Order_Section_DeliveryInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Order_Section_DeliveryInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_order_section_delivery(inputs)
});